import { TimelineCpoeMaterialResponse } from "../eletronic-prescription/electronic-service-timeline/electronic-service-timeline-response";

export enum PrescriptionType {
  ADULT_PARENTERAL_NUTRITION = 'NAN',
  BLADDER_IRRIGATION ='I',
  ENTERAL_NUTRITION = 'SNE',
  GASOTERAPY = 'O',
  GLYCEMIA_CONTROLS_ASSOCIATED_ITEMS = 'IAG',
  GLYCEMIC_CONTROL = 'G',
  INTENCIVE_GLYCEMIC_CONTROL = 'C',
  BLOOD_MANAGEMENT = 'HM',
  MEDICINE = 'M',
  MILKS_AND_INFANT_FORMULAS = 'LD',
  NEONATAL_PARENTERAL_NUTRITION = 'NPN',
  NEONATAL_PARENTERAL_PEDIATRIC = 'NPP',
  NURSING_INTERVENTIONS = 'E',
  ORAL_DIET = 'D',
  ORAL_SUPPLEMENTS = 'S',
  PROCEDURES = 'MP',
  PROCEDURES_ASSOCIATED_ITEMS = 'IA',
  RECOMMENDATIONS = 'R',
  SOLUTION = 'SOL',
}

export const solutionMapping: Record<string, number> = {
  [PrescriptionType.NEONATAL_PARENTERAL_NUTRITION]: 5,
  [PrescriptionType.NEONATAL_PARENTERAL_PEDIATRIC]: 7,
  [PrescriptionType.BLOOD_MANAGEMENT]: 3,
};

export class EmarTimeLineEvent {
  administrationRouteDescription!: string;
  administrationRouteType!: string;
  chemotherapy!: boolean;
  chemotherapyStatus!: string;
  cpoeSequence!: number;
  currentSpeedInfusion!: number;
  description!: string;
  emarStepNumber!: number;
  group!: string;
  groupingNumber!: number;
  id!: number;
  internalProcedureSequence!: number;
  pdoPrn!: boolean;
  isMedication!: string;
  itemCode!: number;
  itemSequence!: number;
  itemStatus!: string;
  itemType!: string;
  label!: string;
  observationDescription!: string;
  prescriptionNumber!: number;
  prescriptionsNumber!: number;
  renderingOrder!: number;
  start!: string;
  status!: string;
  isChemoOrdenDisp!: string;
  nrSeqOrdemChemotherapy!: number;
  listSeqMaterialInfusion!: string;
  delayed!: boolean;
}

export class TimeLineEventMedication extends EmarTimeLineEvent {
  start!: string;
  end!: string;
  reasonForsettlementCode!: number;
  intervalCode!: string;
  itemQuantity!: number;
  prescriptionsNumber!: number;
}

export class TimelineEventPdoPrn extends EmarTimeLineEvent {

}

export class TimelineEventSolution extends EmarTimeLineEvent {
  end!: string;
  totalSolutionStep!: number;
  solutionStepNumber!: number;
}

export default class TimelineContext {

  private static timelineEvent: EmarTimeLineEvent;
  private static cpoeMaterial: TimelineCpoeMaterialResponse | null = null;

  public static get(): EmarTimeLineEvent {
    return this.timelineEvent;
  }

  public static set(timelineEvent: EmarTimeLineEvent): void {
    this.timelineEvent = timelineEvent;
  }

  public static getCpoeMaterial(): TimelineCpoeMaterialResponse | null {
    return this.cpoeMaterial;
  }

  public static setCpoeMaterial(cpoeMaterial: TimelineCpoeMaterialResponse | null): void {
    this.cpoeMaterial = cpoeMaterial;
  }
}

